/**
 * SiteFooter SNS 글리프
 * @description FanTrip 푸터(`fantrip/Dev/FE` `public/icons/sns-*.svg`)의 벡터를 그대로 옮겼다.
 *   원본은 `#5A5E68` 로 칠한 그림 파일이라 다크 테마에서 색이 고정된다 — 여기서는 면을
 *   `currentColor` 로 바꿔 링크의 글자색(`content.neutral.tertiary`)을 따르게 한다.
 *   X 원본에 딸려 온 Figma 배경 사각형은 뺐다.
 */
import type { IconProps } from "@fanwork-web/design-system";

const DEFAULT_SIZE = 20;

export const InstagramGlyph = ({
  size = DEFAULT_SIZE,
  className,
}: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="currentColor"
    aria-hidden
    className={className}
  >
    <path d="M12.8061 0H5.19385C2.32793 0 0 2.32793 0 5.19385V12.8011C0 15.6721 2.32793 18 5.19385 18H12.8011C15.6721 18 17.995 15.6721 17.995 12.8061V5.19385C18 2.32793 15.6721 0 12.8061 0ZM16.3408 12.9369C16.3408 14.8425 14.7972 16.386 12.8916 16.386H5.10838C3.20279 16.386 1.65922 14.8425 1.65922 12.9369V5.15363C1.65922 3.24804 3.20279 1.70447 5.10838 1.70447H12.8966C14.8022 1.70447 16.3458 3.24804 16.3458 5.15363V12.9369H16.3408Z" />
    <path d="M9 4.3743C6.42067 4.3743 4.32905 6.46592 4.32905 9.04525C4.32905 11.6246 6.42067 13.7162 9 13.7162C11.5793 13.7162 13.6709 11.6246 13.6709 9.04525C13.6709 6.46592 11.5793 4.3743 9 4.3743ZM9 12.0721C7.3257 12.0721 5.97318 10.7145 5.97318 9.04525C5.97318 7.37095 7.33073 6.01844 9 6.01844C10.6743 6.01844 12.0268 7.37598 12.0268 9.04525C12.0268 10.7196 10.6743 12.0721 9 12.0721Z" />
    <path d="M13.8268 3.10726C13.2235 3.10726 12.7408 3.59497 12.7408 4.1933C12.7408 4.79665 13.2285 5.27933 13.8268 5.27933C14.4302 5.27933 14.9128 4.79162 14.9128 4.1933C14.9128 3.59497 14.4251 3.10726 13.8268 3.10726Z" />
  </svg>
);

export const XGlyph = ({ size = DEFAULT_SIZE, className }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentColor"
    aria-hidden
    className={className}
  >
    <path d="M14.7915 2.44727H17.3475L11.7641 8.84489L18.3332 17.552H13.1903L9.15936 12.2723L4.55222 17.552H1.99388L7.96531 10.7068L1.6665 2.44846H6.94031L10.5784 7.27346L14.7915 2.44727ZM13.8927 16.0187H15.3094L6.1665 3.90084H4.64746L13.8927 16.0187Z" />
  </svg>
);

export const YoutubeGlyph = ({ size = DEFAULT_SIZE, className }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentColor"
    aria-hidden
    className={className}
  >
    <path d="M17.9862 5.98818C17.7952 5.27243 17.2303 4.70769 16.5121 4.51413C15.2128 4.16669 10.0001 4.16669 10.0001 4.16669C10.0001 4.16669 4.79005 4.16669 3.48829 4.51413C2.77227 4.70522 2.20753 5.26996 2.01411 5.98818C1.66667 7.28747 1.66667 10 1.66667 10C1.66667 10 1.66667 12.7125 2.01411 14.0115C2.20505 14.7277 2.76966 15.2922 3.48829 15.4856C4.78991 15.8333 10.0001 15.8333 10.0001 15.8333C10.0001 15.8333 15.2128 15.8333 16.5121 15.4856C17.228 15.2946 17.7929 14.73 17.9862 14.0115C18.3333 12.7125 18.3333 10 18.3333 10C18.3333 10 18.3333 7.28747 17.9862 5.98818ZM8.33514 12.5V7.4997L12.6648 9.99986L8.33514 12.5Z" />
  </svg>
);
